import React from "react";
import HeaderPanel from "../../components/layout/HeaderPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

const NotFoundPage = () => {
  return <HeaderPanel applyPadding>{formatMessage("cof.base.pagenotfound")}</HeaderPanel>;
};

export default NotFoundPage;
